// import { fitVidsBlocks } from "./../util/fitVids";
// import { mobileMenuToggle } from "./../util/mobileMenu";

export default {
	init() {
		// JavaScript to be fired on all pages
		// mobileMenuToggle();
		// fitVidsBlocks();

		// ----- mobile menu js
		jQuery('.j-mobile-trigger').on('click',function(){
			jQuery('.tsg-off-screen').addClass('active');
		});
		jQuery('.j-mobile-close').on('click',function(){
			jQuery('.tsg-off-screen').removeClass('active');
		});

		// ----- sticky button
		let initScroll = jQuery(window).scrollTop();
		let stickyElem = jQuery('.tsg-banner--button');
		let stickyPoint = jQuery(stickyElem).offset().top;

		if ( initScroll >= stickyPoint ) {
			jQuery(stickyElem).addClass('sticky');
		}

		jQuery(window).scroll(function() {
			let userScroll = jQuery(window).scrollTop();
			if ( userScroll >= stickyPoint ) {
				jQuery(stickyElem).addClass('sticky');
			} else if ( userScroll < stickyPoint ) {
				jQuery(stickyElem).removeClass('sticky');
			}
		});
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	}
};
